import { render, staticRenderFns } from "./realTestAE.vue?vue&type=template&id=e2af9444&scoped=true"
import script from "./realTestAE.vue?vue&type=script&lang=js"
export * from "./realTestAE.vue?vue&type=script&lang=js"
import style0 from "./realTestAE.vue?vue&type=style&index=0&id=e2af9444&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2af9444",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2af9444')) {
      api.createRecord('e2af9444', component.options)
    } else {
      api.reload('e2af9444', component.options)
    }
    module.hot.accept("./realTestAE.vue?vue&type=template&id=e2af9444&scoped=true", function () {
      api.rerender('e2af9444', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/realTest/realTestAE.vue"
export default component.exports